module.exports = __webpack_public_path__ + "static/media/ebay-app-oauth-2.8b5519a8.png";